export const BREAKPOINTS = {
  mdMax: 1023,
  lgMin: 1024,
} as const;
